<template>
    <div class="container">
        <div class="row mt-5">
            <div class="col-12">
                <h4>{{ $lang('Specyfikacja produktów') }}</h4>
                <table class="table simple-table table-striped table-sm">
                    <thead class="thead-dark">
                    <tr>
                        <th scope="col">{{ $lang('Produkt') }}</th>
                        <th scope="col">{{ $lang('Wersja produkcyjna systemu') }}</th>
                        <th scope="col">{{ $lang('Wersja bazy danych') }}</th>
                        <th scope="col">{{ $lang('Wersja systemu operacyjnego') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(sys, index) in systems">
                            <td :data-title="$lang('Produkt')">{{sys.name}}</td>
                            <td :data-title="$lang('System systemu')">
                                <input type="text" class="form-control" :name="'system_ver_' + sys.specification_id"
                                       :id="'system_ver_' + sys.specification_id" autocomplete="chrome-off"
                                       v-model="systems[index].system_version">
                            </td>
                            <td :data-title="$lang('Baza danych')">
                                <input type="text" class="form-control" :name="'database_ver_' + sys.specification_id"
                                       :id="'database_ver_' + sys.specification_id" autocomplete="chrome-off"
                                       v-model="systems[index].database_version">
                            </td>
                            <td :data-title="$lang('System operacyjny')">
                                <input type="text" class="form-control" :name="'os_ver_' + sys.specification_id"
                                       :id="'os_ver_' + sys.specification_id" autocomplete="chrome-off"
                                       v-model="systems[index].os_version">
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button id="products-edit" @click.prevent="save()" type="button" class="btn btn-primary pull-right">
                    {{ $lang('Zapisz') }}
                </button>
            </div>
        </div>
    </div>

</template>

<script>
import ShowNotification from "../../mixins/show-notification";

export default {
    name: "library-product",
    mixins: [ShowNotification],
    props: ['systems', 'saveUrl'],
    methods: {
        save() {
            let self = this;
            axios.post(this.saveUrl, {products: this.systems})
                 .then(function (response) {
                     self.showNotification('success', 'Zapisano');
                 })
                 .catch((error) => {
                     self.showNotification('error', 'Wystąpił błąd przy próbie zapisu');
                     console.log(error);
                 });
        }
    }
}
</script>
